const verification_record = {
    /** UNTRANSLATED */
    not_found: 'Verification record not found.',
    /** UNTRANSLATED */
    permission_denied: 'Permission denied, please re-authenticate.',
    /** UNTRANSLATED */
    not_supported_for_google_one_tap: 'This API does not support Google One Tap.',
};
export default Object.freeze(verification_record);
